export const checkIE = () => {
    if(/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
        window.location = 'http://wiki.megatec.ru/index.php/Мастер-Тур(15):Поддерживаемые_версии_браузеров';
    }
};

export const getCookieValueByName = (name) => {
    let cookie = document.cookie
        .split(";")
        .find(x => x.includes(name + "="));

    return cookie ? cookie.split("=")[1] : null
};

export const cachingDecorator = function(func) {
    let cache = new Map();

    return function(x, reset = false) {
        if (reset){
            cache.clear();
            return;
        }

        if (cache.has(x)) {    // если кеш содержит такой x,
            return cache.get(x); // читаем из него результат
        }

        let result = func(x); // иначе, вызываем функцию

        cache.set(x, result); // и кешируем (запоминаем) результат
        return result;
    };
};

export const fullCopy = (obj) => {
    if (typeof obj !== 'object' || obj === null) return obj;

    let res = Array.isArray(obj) ? [] : {};
    for (let i in obj) {
        res[i] = fullCopy(obj[i])
    }

    return res;
};

export const checkEquality = (foo, bar) => {
    if ( foo === bar) return true;
    if (typeof foo !== typeof bar) return false;
    if (typeof foo !== 'object' || foo === null) return foo === bar;

    let res = true;

    const isArray = Array.isArray(foo);
    if (isArray) {
        if (foo.length !== bar.length) return false;

        for (let i = 0; i < foo.length; i++) {
            if (
                typeof foo[i] === 'object' && !checkEquality(foo[i], bar[i]) ||
                typeof foo[i] !== 'object' && foo[i] !== bar[i]
            ) {
                res = false;
                break;
            }
        }
    } else {
        const fooKeys = Object.keys(foo);
        const barKeys = Object.keys(bar);
        if (!checkEquality(fooKeys, barKeys)) return false;

        const fooValues = Object.values(foo);
        const barValues = Object.values(bar);
        if (!checkEquality(fooValues, barValues)) return false;
    }

    return res;
};

export const getArrayDifference = (arr1 = [], arr2 = []) => {
    if (!arr2.length) return arr1;

    const a = arr1.length >= arr2.length ? arr1 : arr2;
    const b = arr1.length < arr2.length ? arr1 : arr2;
    const res = fullCopy(a);
    return res.filter(x => {
        if (!b.map(x2 => JSON.stringify(x2)).includes(JSON.stringify(x)))
            return x
    })
};

export const getLocalTimeLimit = (str) => {
    if (!str) return;

    return new Date(str).toLocaleString()
};

let id = 0;
export const uniqueId = () => {
    id++
    return id
}
